import { create } from "zustand";

type State = {
    selected_partner: string | null;
    selected_customer: string | null;
    customers_list: Customer[] | null;
};

type Actions = {
    setselected_partner: (v: string | null) => void;
    setselected_customer: (v: string | null) => void;
    setcustomers_list: (v: Customer[] | null) => void;
    reset: () => void;
};

const buildInitialState = (): State => ({
    selected_partner: null,
    selected_customer: null,
    customers_list: null,
});

const useCustomerSettingsStore = create<State & Actions>((set) => ({
    ...buildInitialState(),

    setselected_partner: (v) => set({ selected_partner: v }),
    setselected_customer: (v) => set({ selected_customer: v }),
    setcustomers_list: (v) => set({ customers_list: v }),

    reset: () => set(buildInitialState()),
}));

export default useCustomerSettingsStore;
